import { FileDown, FileSpreadsheet, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';

export function HrExportButtons({
  onExport,
  disabled = false,
  exporting = null,
}: {
  onExport: (format: 'csv' | 'xlsx') => void;
  disabled?: boolean;
  exporting?: 'csv' | 'xlsx' | null;
}) {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onExport('csv')}
        disabled={disabled || exporting !== null}
      >
        {exporting === 'csv' ? (
          <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
        ) : (
          <FileDown className="mr-1.5 h-4 w-4" />
        )}
        Export CSV
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onExport('xlsx')}
        disabled={disabled || exporting !== null}
      >
        {exporting === 'xlsx' ? (
          <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
        ) : (
          <FileSpreadsheet className="mr-1.5 h-4 w-4" />
        )}
        Export Excel
      </Button>
    </div>
  );
}
